import { useTranslation } from '@mc/i18n'

import FooterContentDesktop from './FooterContentDesktop'
import FooterContentMobile from './FooterContentMobile'
import Sticky from '../Sticky'

const GuestPassStickyFooter = () => {
  const { t } = useTranslation('@mc/next')
  return (
    <Sticky role='region' aria-label={t('guestPass.footer.ariaLabel')}>
      <div className='container mc-py-4'>
        <div className='d-none d-md-block'>
          <FooterContentDesktop />
        </div>
        <div className='d-block d-md-none'>
          <FooterContentMobile />
        </div>
      </div>
    </Sticky>
  )
}

export default GuestPassStickyFooter
